export default "__VITE_ASSET__D3P6EcOh__"